import { Query } from 'cogent-js';
import BaseApiService from './base';

export default class CaseNotesApiService extends BaseApiService {
  constructor() {
    super();
    this.query = new Query();
  }

  fetchCaseNotes(patientId, sinceId = null) {
    return this.request({
      method: 'get',
      url: `/patients/${patientId}/case-notes?filter[since_id]=${sinceId}`
    });
  }

  addCaseNote(patientId, message) {
    return this.request({
      method: 'post',
      url: `/patients/${patientId}/case-notes`,
      data: { message }
    });
  }
}
